import React from "react";
import { Box, Typography, CircularLoader } from "@bca/ui-library";

import { ICollectionAddress } from "./Collections";

interface CollectionsContentProps {
  collectionAddress: ICollectionAddress | null;
  locationName: string;
  isLoading: boolean;
}

const CollectionsContent: React.FunctionComponent<CollectionsContentProps> = ({
  collectionAddress,
  locationName,
  isLoading,
}) => {
  return (
    <Box m={0} mt={8} mb={8}>
      {isLoading && (
        <CircularLoader title="LoadData" width="15px" height="15px" />
      )}

      {!isLoading && (
        <>
          <Typography m={0}>{locationName}</Typography>
          <Typography m={0}>{collectionAddress?.addressLine1}</Typography>
          <Typography m={0}>{collectionAddress?.addressLine2}</Typography>
          <Typography m={0}>{collectionAddress?.townCity}</Typography>
          <Typography m={0}>{collectionAddress?.postcode}</Typography>
        </>
      )}
    </Box>
  );
};

export default CollectionsContent;
